<template>
  <v-form class="py-3" v-model="valid" @submit.prevent="submit">
    <v-text-field
      v-model="email"
      label="Email"
      prepend-icon="mail"
      :rules="[(v) => !!v || 'Invalid email']"
      required
    ></v-text-field>
    <v-text-field
      v-model="password"
      prepend-icon="lock"
      :append-icon="show1 ? 'visibility' : 'visibility_off'"
      :type="show1 ? 'text' : 'password'"
      name="password"
      label="Password"
      :rules="[(v) => !!v || 'Invalid password']"
      @click:append="show1 = !show1"
      required
    ></v-text-field>

    <v-row justify="end">
      <v-btn text x-small @click="$emit('forgot')">Forgot Password</v-btn>
    </v-row>

    <v-btn class="ma-4" color="primary" type="submit" :disabled="!valid">Login</v-btn>

    <OtpCodeDialog
      v-model="showOtpDialog"
      :email="this.email"
      :password="this.password"
      :reference="this.reference"
      :expiresAt="this.expiresAt"
      :loggedin="loggedin"
    />
  </v-form>
</template>

<script>
import OtpCodeDialog from "./OtpCodeDialog";
export default {
  props: {
    // DOM is destroyed when loading, so need persistent function
    // ($emit won't work here)
    loggedin: Function,
  },
  components: {
    OtpCodeDialog,
  },
  data() {
    return {
      valid: true,
      email: null,
      password: null,
      show1: false,
      showOtpDialog: false,
      reference: "",
      expiresAt: "",
    };
  },
  methods: {
    submit() {
      this.$root.$loading.open("Logging in");
      this.$store
        .dispatch("loginWithOtp", {
          email: this.email,
          password: this.password,
        })
        .then((data) => {
          if (data.token) {
            return this.loggedin(data);
          }

          this.reference = data.reference;
          this.expiresAt = data.expires_at;
          this.showOtpDialog = true;
        })
        .catch((err) => this.loggedin(null, err))
        .finally(() => this.$root.$loading.end());
    },
  },
  mounted() {
    // Pull email and password in saved cached
    // Autologin
    this.$store.dispatch("autoLogin").catch((err) => this.$root.$error(err));
  },
};
</script>

<style></style>
